import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Box } from 'grommet/components/Box';
import { Text } from 'grommet/components/Text';
import { Tabs } from 'grommet/components/Tabs';
import { Tab } from 'grommet/components/Tab';
import { Anchor } from 'grommet/components/Anchor';
import ReactTable from 'react-table';
import Pagination from './../Components/Pagination';
import pdf from '../Assets/document/pdf/CambioCoba.pdf'
import { GetOutstandingsCtrl } from '../Controllers/Outstanding/GetOutstandingsCtrl';
import ModalErrorTimeout from '../Components/ModalErrorTimeout';
import { loader, formatAmount } from '../Utils/Utility';


class Insoluti extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    }
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            status: '',
            showTimeoutModal: false,
            isRicerca: false
        }
        
    }

    componentDidMount() {
        var token = sessionStorage.getItem('token')
        var ids = sessionStorage.getItem('ids')
         const self = this;
         this.setState({
            isRicerca: true
        })
         GetOutstandingsCtrl(function (data, status) {
             self.setState({
                 data: data === undefined ? [] : data,
                 status: status,
                 isRicerca: false
            });
        }, function (error) {
             self.setState({
                status: error
             }, function(){
                if(this.state.status === 500 || this.state.status === 400 || this.state.status === 404 || this.state.status === 403){
                    this.props.history.push({
                        pathname: '/ErrorPage',
                        state: this.state
                    })  
                } else if (this.state.status === 401) {
                    this.setState({
                        showTimeoutModal: true
                    })
                } 
            })

         }, this.state, token, ids);
     }

     

    render() {

        const hasData = (Array.isArray(this.state.data) && this.state.data.length > 0 && this.state.data !== null && this.state.data !== undefined)


        const columns = [
            {
                Header: 'CODICE ESERCIZIO',
                accessor: 'branchCode',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'TITOLARE',
                accessor: 'merchant',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'IMPORTO',
                accessor: 'amount',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                },
                Cell: (row) => formatAmount(row.original.amount)
            },
            {
                Header: 'DATA VALUTA',
                accessor: 'vDate',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'DATA CONTABILE',
                accessor: 'cDate',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'CAUSALE',
                accessor: 'reason',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            }
        ]


        return (
            <Box>
                {this.state.showTimeoutModal ? <ModalErrorTimeout /> : ''}
                <Box align='center' className='content' style={{ backgroundColor: '#f9f9f9', marginTop: '0' }}>

                    <Box className='contentbox'>

                        <Box pad='medium' align='start' style={{ paddingBottom: '50px' }}>
                            <Text className='titlehome'>Insoluti</Text>
                        </Box>

                        <Box className='contentbox' direction='row'>
                            <Tabs>
                                <Tab title='Verifica Insoluti'>

                                    
                                        <Box>

                                            <Box direction='row' style={{ paddingTop: '40px' }}>
                                                <Box pad='large' style={{ width: '100%', padding: '0' }}>

                                                {hasData ?

                                                    <ReactTable
                                                        PaginationComponent={Pagination}
                                                        data={this.state.dataTable}
                                                        columns={columns}
                                                        sortable={true}
                                                        resizable={true}
                                                        showPagination={true}
                                                        loading={false}
                                                        defaultPageSize={10}
                                                        style={{ paddingBottom: '20px' }} />

                                                    : this.state.isRicerca ?
                                                        loader

                                                    : 'Al momento non risultano insoluti.' }

                                                </Box>
                                            </Box>

                                        </Box> 
                                    
                                </Tab>
                                <Tab title='Scarica Modulo'>
                                    <Box className='downloadDocument' margin='large'>
                                        <Anchor href={pdf} a11yTitle='Apri e scarica il modulo per l&apos;allineamento delle Coordinate bancarie e del Legale Rappresentante da questo link!' target='blank'>
                                            Scarica il modulo per l'allineamento delle Coordinate bancarie e del Legale Rappresentante.
                                        </Anchor>
                                    </Box>
                                </Tab>
                            </Tabs>
                        </Box>

                    </Box>
                </Box>

            </Box>
        )
    }
}
export default Insoluti;


